<div class="back-button-container">
  <button (click)="cancel()" class="btn btn-secondary" type="button">
    {{ 'Back' | translate }}
  </button>
</div>

<h1>
  <a class="home-link" [routerLink]="['/' + getHomePath()]">
    <i class="fa fa-home" aria-hidden="true"></i>
    <span>
      @if(isCreateMode()){
        {{ 'Create new customer' | translate }}
      }
      @else {
        {{ 'Edit customer' | translate }}
      }
    </span>
  </a>
</h1>

<div class="overview-styling">
  <div *ngIf="getLoading()" class="ajax_loading_wrapper">
    <div class="ajax_loading"></div>
  </div>

  <div class="container-content" fxLayout="column" fxFlex fxLayoutGap="10px">

    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
      <div class="top-actions" fxFlex="45" fxFlex.xs="100" fxLayout="row" fxLayoutGap="10px"
           fxLayoutAlign="start center">
        @if(isEditMode()) {
          <button type="button" class="btn btn-secondary" (click)="manageUsers()">
            {{ 'Show users of this customer' | translate }}
          </button>
        }
      </div>
    </div>

    <form [formGroup]="getCustomerDetailsForm()" fxLayout="column" fxFlex novalidate class="ng"
          (ngSubmit)="saveCustomer(getCustomerDetailsForm().value)">

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label class="control-label" fxFlex="30">
          {{ 'Status' | translate }}
        </label>
        <div class="input-container" fxLayout="column" fxLayout.xs="column" fxFlex="70">
          <label for="active">
            <input
              id="active"
              type="checkbox"
              class="checkbox"
              name="active"
              formControlName="active"> {{ 'active' | translate }}
          </label>
          <label for="confirm">
            <input
              id="confirm"
              type="checkbox"
              class="checkbox"
              name="confirm"
              formControlName="confirm">
            {{ 'confirmed' | translate }}
          </label>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="company" class="control-label" fxFlex="30">
          {{ 'Company' | translate }} *
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <input
            type="text"
            class="form-control form-control-border"
            name="company" id="company"
            formControlName="company">
          <div class="feedback-wrapper"
               *ngIf="getCustomerDetailsForm().controls['company'].errors && (getCustomerDetailsForm().controls['company'].dirty || getCustomerDetailsForm().controls['company'].touched)">
            <small class="feedback" [hidden]="!getCustomerDetailsForm().controls['company'].errors.required">
              {{ 'Required' | translate }}.
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="customerNr" class="control-label" fxFlex="30">
          {{ 'Customer-no' | translate }} *
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <input
            type="text"
            class="form-control form-control-border has-danger"
            maxlength="10"
            name="customerNr" id="customerNr"
            formControlName="customerNr">
          <div class="feedback-wrapper"
               *ngIf="getCustomerDetailsForm().controls['customerNr'].errors && (getCustomerDetailsForm().controls['customerNr'].dirty || getCustomerDetailsForm().controls['customerNr'].touched)">
            <small class="feedback" [hidden]="!getCustomerDetailsForm().controls['customerNr'].errors.required">
              {{ 'Required' | translate }}.
            </small>
            <small [hidden]="!getCustomerDetailsForm().controls['customerNr'].errors.pattern" class="feedback">
              {{ 'Customer number must contain only numbers' | translate }}
            </small>
          </div>
        </div>
      </div>

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label class="control-label" fxFlex="30">
          {{ 'Target group' | translate }} *
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <ng-select
            [items]="getListOfTargetGroups()"
            bindLabel="label"
            bindValue="value"
            [clearable]="false"
            [ngClass]="{'select-with-value': getSelectWithInitialValue()}"
            placeholder="{{'Please select...' | translate}}"
            notFoundText="{{'No results found' | translate}}"
            (change)="onTargetGroupSelected($event)"
            (remove)="onTargetGroupDeselected($event)"
            formControlName="targetGroup">
          </ng-select>
          <div class="feedback-wrapper"
               *ngIf="getCustomerDetailsForm().controls['targetGroup'].errors && (getCustomerDetailsForm().controls['targetGroup'].dirty || getCustomerDetailsForm().controls['targetGroup'].touched)">
            <small class="feedback" [hidden]="!getCustomerDetailsForm().controls['targetGroup'].errors.required">
              {{ 'Required' | translate }}.
            </small>
          </div>
        </div>
      </div>


      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label class="control-label" fxFlex="30">
          {{ 'Country' | translate }} *
        </label>
        <div class="input-container" fxLayout="column" fxFlex>
          <ng-select
            [items]="getListOfCountries()"
            bindLabel="label"
            bindValue="value"
            [clearable]="false"
            placeholder="{{'Please select...' | translate}}"
            notFoundText="{{'No results found' | translate}}"
            formControlName="countryCode">
          </ng-select>
          <div class="feedback-wrapper"
               *ngIf="getCustomerDetailsForm().controls['countryCode'].errors && (getCustomerDetailsForm().controls['countryCode'].dirty || getCustomerDetailsForm().controls['countryCode'].touched)">
            <small class="feedback" [hidden]="!getCustomerDetailsForm().controls['countryCode'].errors.required">
              {{ 'Required' | translate }}.
            </small>
          </div>
        </div>
      </div>


      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="companyLogo" class="control-label" fxFlex="30">
          {{ 'Logo' | translate }}
        </label>
        <div class="input-container" fxLayout="column" fxFlex [ngStyle]="{'height': '102px'}"
             [ngClass]="{'invalid-photo': getCustomerDetailsForm().errors && (getCustomerDetailsForm().errors.invalidImageType || getCustomerDetailsForm().errors.invalidImageSize)}">

          <div class="add-photo-container" fxLayout="column" fxLayoutAlign="space-between end">
            <div class="photo-icon-container logo"
                 [ngClass]="{'existing-photo': getCustomerDetailsForm().controls.companyLogo.value || getEditedCustomer().companyLogo}">
              <i class="fa fa-camera fa-lg" aria-hidden="true"
                 [ngClass]="{'d-none': getCustomerDetailsForm().controls.companyLogo.value || getEditedCustomer().companyLogo}"></i>
              <img [src]="getCustomerDetailsForm().controls.companyLogo.value" [width]="getImageWidth()"
                   [height]="getImageHeight()"
                   [ngClass]="{'d-none': !getCustomerDetailsForm().controls.companyLogo.value}">
            </div>
            <div class="input-button-container"
                 [ngClass]="{'two-buttons': getCustomerDetailsForm().controls.companyLogo.value}">
              <label for="companyLogo">
                <div class="select-image-btn"
                     *ngIf="!getCustomerDetailsForm().controls.companyLogo.value && !getEditedCustomer().companyLogo">{{ 'Add logo' | translate }}
                </div>
                <div class="select-image-btn"
                     *ngIf="getCustomerDetailsForm().controls.companyLogo.value || getEditedCustomer().companyLogo">{{ 'Change logo' | translate }}
                </div>
              </label>
              <input
                #fileInput
                type="file"
                class="fileInput"
                id="companyLogo" name="companyLogo"
                accept="image/*"
                (change)="onFileInputChange($event)">
            </div>
            <div class="remove-button-container"
                 *ngIf="getCustomerDetailsForm().controls.companyLogo.value || getEditedCustomer().companyLogo">
              <div class="remove-image-btn" (click)="deleteLogo()">{{ 'Remove logo' | translate }}</div>
            </div>
          </div>
          <div class="feedback-wrapper photo" *ngIf="getCustomerDetailsForm().errors" fxLayout="column">
            <small class="feedback">
              {{ 'Invalid image' | translate }}.
            </small>
            <small class="feedback" [hidden]="!getCustomerDetailsForm().errors.invalidImageType">
              {{ 'Please choose from one of the following image formats: jpg, jpeg, png, giff' | translate }}.
            </small>
            <small class="feedback" [hidden]="!getCustomerDetailsForm().errors.invalidImageSize">
              {{ 'The maximum photo size can be 2MBs' | translate }}.
            </small>
          </div>
        </div>
      </div>

      @if(isEditMode()) {
        <div class="form-group" fxLayout="row" fxLayout.xs="column">
          <label for="contactPerson" class="control-label" fxFlex="30">
            {{ 'Contact person' | translate }}
          </label>
          <div class="input-container" fxLayout="column" fxFlex>
            <input
              type="text"
              class="form-control"
              name="contactPerson" id="contactPerson"
              formControlName="contactPerson">
          </div>
        </div>
      }

      <div class="form-group" fxLayout="row" fxLayout.xs="column">
        <label for="authorization" class="control-label" fxFlex="30">
          {{ 'Authorizations' | translate }}
        </label>
        <div class="input-container disabled" fxLayout="column" fxFlex>
          <ng-select
            [items]="getAllPossibleRoles()"
            bindLabel="label"
            bindValue="value"
            [clearable]="true"
            [multiple]="true"
            [closeOnSelect]="false"
            formControlName="roles">
          </ng-select>
          <div class="feedback-wrapper" *ngShow="getCustomerDetailsForm().controls['roles'].value">
            <small [hidden]="getAppManagerRolesValidationResult()" class="feedback">
              {{ 'Usermanagement role is required when assigning an app manger role' | translate }}
            </small>
          </div>
        </div>
      </div>

      <div fxLayout="column" fxLayoutGap="10px">
        <div class="bottom-actions" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="start center">
          <div fxFlex="45" fxFlex.xs="100" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">

            <button class="btn btn-success" type="submit" [disabled]="getCustomerDetailsForm().invalid">
              <span>
                @if (isEditMode()) {
                  {{ 'Update customer' | translate }}
                } @else {
                  {{ 'Create customer' | translate }}
                }
              </span>
            </button>

          </div>
        </div>
      </div>

    </form>

  </div>
</div>
<div class="divider"></div>
